import { ReactNode } from 'react'
import { Container } from './styles'

interface ContainerFormProps {
  children: ReactNode
  textBtn?: string
}

export const ContainerForm = ({ children, textBtn }: ContainerFormProps) => {
  return (
    <Container>
      {children}
      {textBtn && <input type='submit' value={textBtn} />}
    </Container>
  )
}
